import { render } from "./MalawModalContainer.vue?vue&type=template&id=084248cc&ts=true"
import script from "./MalawModalContainer.vue?vue&type=script&lang=ts"
export * from "./MalawModalContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__